import { Component, Input, OnInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit, OnChanges {
  @Input() displayError = false;
  @Input() displayErrorMessage = '';

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(){
  }

}
